import type { I18nTranslation } from '@crehana/i18n';

import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

export const RenewalCardLocalesBundle: I18nTranslation = { es, pt, en };
